/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Format_Playing_TitleInputs */

const en_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playing Lesson`)
};

const es_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clase en el campo`)
};

const de_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielstunde`)
};

const zh_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下场课程`)
};

const ar_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`درس على الملعب`)
};

const fr_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leçon sur le parcours`)
};

const vi_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buổi học trên sân`)
};

const sw_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somo la Kucheza`)
};

const th_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทเรียนบนสนาม`)
};

const bs_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čas na terenu`)
};

const ja_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コースレッスン`)
};

const ko_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`라운드 레슨`)
};

const pt_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aula em campo`)
};

const it_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lezione in campo`)
};

const sv_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektion på banan`)
};

const nl_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les op de baan`)
};

const da_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektion på banen`)
};

const nb_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time på banen`)
};

const fi_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kenttätunti`)
};

const pl_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekcja na polu`)
};

const ru_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Урок на поле`)
};

const tr_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sahada Ders`)
};

const hi_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोर्स पर पाठ`)
};

const id_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les di Lapangan`)
};

const ms_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran di Padang`)
};

const cs_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekce na hřišti`)
};

const el_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μάθημα στο γήπεδο`)
};

const he_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעור במגרש`)
};

const af_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spelles`)
};

const hu_lessons_format_playing_title = /** @type {(inputs: Lessons_Format_Playing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pályaóra`)
};

/**
* | output |
* | --- |
* | "Playing Lesson" |
*
* @param {Lessons_Format_Playing_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_format_playing_title = /** @type {((inputs?: Lessons_Format_Playing_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Format_Playing_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_format_playing_title(inputs)
	if (locale === "de") return de_lessons_format_playing_title(inputs)
	if (locale === "zh") return zh_lessons_format_playing_title(inputs)
	if (locale === "ar") return ar_lessons_format_playing_title(inputs)
	if (locale === "fr") return fr_lessons_format_playing_title(inputs)
	if (locale === "vi") return vi_lessons_format_playing_title(inputs)
	if (locale === "sw") return sw_lessons_format_playing_title(inputs)
	if (locale === "th") return th_lessons_format_playing_title(inputs)
	if (locale === "bs") return bs_lessons_format_playing_title(inputs)
	if (locale === "ja") return ja_lessons_format_playing_title(inputs)
	if (locale === "ko") return ko_lessons_format_playing_title(inputs)
	if (locale === "pt") return pt_lessons_format_playing_title(inputs)
	if (locale === "it") return it_lessons_format_playing_title(inputs)
	if (locale === "sv") return sv_lessons_format_playing_title(inputs)
	if (locale === "nl") return nl_lessons_format_playing_title(inputs)
	if (locale === "da") return da_lessons_format_playing_title(inputs)
	if (locale === "nb") return nb_lessons_format_playing_title(inputs)
	if (locale === "fi") return fi_lessons_format_playing_title(inputs)
	if (locale === "pl") return pl_lessons_format_playing_title(inputs)
	if (locale === "ru") return ru_lessons_format_playing_title(inputs)
	if (locale === "tr") return tr_lessons_format_playing_title(inputs)
	if (locale === "hi") return hi_lessons_format_playing_title(inputs)
	if (locale === "id") return id_lessons_format_playing_title(inputs)
	if (locale === "ms") return ms_lessons_format_playing_title(inputs)
	if (locale === "cs") return cs_lessons_format_playing_title(inputs)
	if (locale === "el") return el_lessons_format_playing_title(inputs)
	if (locale === "he") return he_lessons_format_playing_title(inputs)
	if (locale === "af") return af_lessons_format_playing_title(inputs)
	if (locale === "hu") return hu_lessons_format_playing_title(inputs)
	return en_lessons_format_playing_title(inputs)
});